import React from 'react';
import { MotionWrap } from '../../../wrapper';
import Settings from '../../../wrapper/Settings';
import './Spravy.scss';

const Zmluvy = () => {
  return (
    <div className="app__header">
      <h1 className="blog">Vyhlásenie o prístupnosti</h1>
      <p>Základná umelecká škola, Irkutská 1, 040 12 Košice má záujem zabezpečiť prístupnosť svojho
        webového sídla v súlade so zákonom č. 95/2019 Z. z. o informačných technológiách vo verejnej
        správe a o zmene a doplnení niektorých zákonov v znení neskorších predpisov (ďalej len „zákon
        č. 95/2019 Z. z. o ITVS“) a príslušnými vykonávacími predpismi.
      </p>
      <p>Toto vyhlásenie o prístupnosti sa vzťahuje na webové sídlo <a href="https://www.zusirkutska.sk/" target="_blank" rel="noopener noreferrer">https://www.zusirkutska.sk/</a></p>
      <h2>Stav súladu</h2>
      <p>Toto webové sídlo je v čiastočnom súlade so zákonom č. 95/2019 Z. z. o ITVS a príslušnými
        vykonávacími predpismi vzhľadom na prvky nesúladu uvedené nižšie.
      </p>
      <h2>Neprístupný obsah</h2>
      <p>Obsah uvedený nižšie nie je prístupný z týchto dôvodov: nesúlad s pravidlami prístupnosti podľa
        § 14 vyhlášky Úradu podpredsedu vlády Slovenskej republiky pre investície a informatizáciu
        č. 78/2020 Z. z. o štandardoch pre informačné technológie verejnej správy v znení vyhlášky
        č. 546/2021 Z. z.
      </p>
      <h2>Neprístupný obsah a jeho odôvodnenie</h2>
      <ul>
        <li><strong>1. Netextový obsah:</strong> Niektoré obrázky nemajú priradený alternatívny text, čo
          znemožňuje ich správnu interpretáciu pomocou asistenčných technológií.
        </li>
        <li><strong>2. Titulky pre multimédiá:</strong> Vložené videozáznamy neobsahujú titulky, čo obmedzuje
          dostupnosť obsahu pre osoby so sluchovým postihnutím.
        </li>
        <li><strong>3. Ovládanie pomocou klávesnice:</strong> Niektoré interaktívne prvky (napr. rozbaľovacie
          menu, informačné bannery) nie je možné ovládať výhradne pomocou klávesnice.
        </li>
        <li><strong>4. Jazyk dokumentu:</strong> Niektoré zverejnené PDF dokumenty nemajú definovaný jazyk
          obsahu, čo sťažuje ich použitie čítačkami obrazovky.
        </li>
        <li><strong>5. Stavové správy:</strong> Systémové hlásenia (napr. potvrdenie o odoslaní formulára)
          nie sú implementované tak, aby boli čitateľné asistenčnými technológiami.
        </li>
        <li><strong>6. Nevhodné formáty dokumentov:</strong> Webové sídlo obsahuje dokumenty vo formátoch
          ako DOCX, PDF, JPG, AVI a pod., ktoré nie sú vždy dostupné v alternatívnych, prístupnejších
          formátoch (napr. HTML).
        </li>
      </ul>
      <h2>Odôvodnenie nedostatkov (obhajoba)</h2>
      <ul>
        <li><strong>1. Netextový obsah:</strong> Alternatívne texty slúžia predovšetkým na SEO účely a neboli
          predmetom požiadaviek zo strany objednávateľa projektu.
        </li>
        <li><strong>2. Titulky pre multimédiá:</strong> Videozáznamy neobsahujú titulky, keďže ide len o
          obrazové/prehrávacie materiály bez zvukového alebo hovoreného obsahu.
        </li>
        <li><strong>3. Ovládanie pomocou klávesnice:</strong> Prispôsobenie všetkých interaktívnych prvkov pre
          klávesnicové ovládanie nebolo zahrnuté v pôvodnej špecifikácii projektu.
        </li>
        <li><strong>4. Jazyk dokumentu:</strong> PDF dokumenty sú umiestnené na externých úložiskách (napr.
          eGov, Sharedlink), kde sú asistenčné nástroje (napr. definovanie jazyka) dostupné až po ich
          stiahnutí a otvorení v špecializovaných softvéroch.
        </li>
        <li><strong>5. Stavové správy:</strong> Stavové hlásenia sú implementované vo forme vizuálnej
          notifikácie, nie však s podporou pre zrakovo postihnutých používateľov. Doplnenie tejto
          funkcionality nebolo v rozsahu pôvodného zadania.
        </li>
        <li><strong>6. Nevhodné formáty dokumentov:</strong> Formáty ako DOCX, PDF a iné sú použité z dôvodu
          povinnej dokumentácie (napr. faktúry, objednávky), ktorá je generovaná a sprístupňovaná
          prostredníctvom externých systémov, nad ktorými prevádzkovateľ nemá úplnú kontrolu.
        </li>
      </ul>
      <h2>Vypracovanie tohto vyhlásenia o prístupnosti</h2>
      <p>Toto vyhlásenie bolo vypracované 14.04.2025</p>
      <p>Vyhodnotenie súladu webového sídla s požiadavkami zákona č. 95/2019 Z. z. o ITVS a príslušnými
        vykonávacími predpismi bolo vykonané samohodnotením.
      </p>
      <p>Vyhlásenie bolo naposledy aktualizované 14.04.2025.</p>
      <h2>Spätná väzba a kontaktné informácie</h2>
      <p>V prípade akýchkoľvek problémov s prístupnosťou webového sídla nás, prosím, kontaktujte na
        e-mailovej adrese: <a href="mailto:zusirkutska@gmail.com">zusirkutska@gmail.com</a>
      </p>
      <p>Správcom a prevádzkovateľom webového sídla je Základná umelecká škola, Irkutská 1, 040 12 Košice.</p>
      <h2>Vynucovacie konanie</h2>
      <p>V prípade neuspokojivej odpovede na oznámenie nesúladu webového sídla s pravidlami prístupnosti
        podľa § 14 vyhlášky Úradu podpredsedu vlády Slovenskej republiky pre investície a informatizáciu
        č. 78/2020 Z. z. o štandardoch pre informačné technológie verejnej správy v znení vyhlášky č.
        546/2021 Z. z. v rámci mechanizmu spätnej väzby alebo v prípade neuspokojivej odpovede na žiadosť
        o informáciu alebo obsah, ktorý je vyňatý z rozsahu pôsobnosti zákona č. 95/2019 Z. z. o ITVS v
        rámci mechanizmu spätnej väzby, sa môžete obrátiť na Ministerstvo investícií, regionálneho
        rozvoja a informatizácie Slovenskej republiky, ako na subjekt poverený presadzovaním Smernice
        (EÚ) 2016/2102, na adrese:
      </p>
      <p>
        Ministerstvo investícií, regionálneho rozvoja a informatizácie Slovenskej republiky<br />
        Pribinova 25<br />
        811 09 Bratislava<br />
        alebo na e-mailovej adrese: <a href="mailto:standard@mirri.gov.sk">standard@mirri.gov.sk</a>.
      </p>
    </div>
  );
};

export default Settings(MotionWrap(Zmluvy, 'app__skills'), 'skills', 'app__whitebg');
